// Messages service - handles all messaging-related API calls
import api from './api';

export const messagesService = {
  // Get all conversations
  getConversations: async (type = null) => {
    const response = await api.get('/messages/conversations', {
      params: type ? { type } : {},
    });
    return response.data;
  },

  // Create or get conversation
  createConversation: async (participantId) => {
    const response = await api.post('/messages/conversations', { participantId });
    return response.data;
  },

  // Get messages for a conversation
  getMessages: async (conversationId, limit = 50, offset = 0) => {
    const response = await api.get(`/messages/conversations/${conversationId}/messages`, {
      params: { limit, offset },
    });
    return response.data;
  },

  // Send message
  sendMessage: async (conversationId, content, mediaUrl = null, mediaType = null) => {
    const response = await api.post('/messages/send', {
      conversationId,
      content,
      mediaUrl,
      mediaType,
    });
    return response.data;
  },

  // Delete message
  deleteMessage: async (messageId) => {
    const response = await api.delete(`/messages/${messageId}`);
    return response.data;
  },

  // Get unread message counts
  getUnreadCounts: async () => {
    const response = await api.get('/messages/unread-counts');
    return response.data;
  },

  // Get total unread count (alias for compatibility)
  getUnreadCount: async () => {
    const response = await api.get('/messages/unread-counts');
    return response.data;
  },

  // Mark messages as read
  markAsRead: async (conversationId) => {
    const response = await api.put(`/messages/conversations/${conversationId}/read`);
    return response.data;
  },
};

export default messagesService;
